// Info from calories.info, all 1 serving and in grams, calories in cal
//  https://www.calories.info/food/'Produce'

const listOfStock = [
    // Vegetables
    { title: 'Alfalfa Sprouts', department: 'Produce'},
    { title: 'Artichoke', serving: 128, calories: 60, department: 'Produce'},
    { title: 'Arugula', serving: 2, calories: 1, department: 'Produce'},
    { title: 'Asparagus', serving: 12, calories: 1, department: 'Produce'},
    { title: 'Aubergine', serving: 458, calories: 115, department: 'Produce'},
    { title: 'Bean Sprouts', department: 'Produce'},
    { title: 'Beetroot', serving: 82, calories: 35, department: 'Produce'},
    { title: 'Bell Pepper', serving: 73, calories: 15, department: 'Produce'},
    { title: 'Black Olives', serving: 2.7, calories: 2, department: 'Produce'},
    { title: 'Brocolli', serving: 608, calories: 207, department: 'Produce'},
    { title: 'Brussels Sprouts', serving: 19, calories: 8, department: 'Produce'},
    { title: 'Cabbage', serving: 908, calories: 227, department: 'Produce'},
    { title: 'Capsicum', serving: 45, calories: 12, department: 'Produce'},
    { title: 'Carrot', serving: 61, calories: 25, department: 'Produce'},
    { title: 'Cauliflower', serving: 13, calories: 3, department: 'Produce'},
    { title: 'Celery', serving: 40, calories: 6, department: 'Produce'},
    { title: 'Chard', serving: 48, calories: 9, department: 'Produce'},
    { title: 'Cheery Tomato', serving: 20, calories: 20, department: 'Produce'},
    { title: 'Chicory', serving: 53, calories: 38, department: 'Produce'},
    { title: 'Chinese Cabbage', serving: 840, calories: 134, department: 'Produce'},
    { title: 'Chives', serving: 3, calories: 1, department: 'Produce'},
    { title: 'Collard Greens', serving: 36, calories: 12, department: 'Produce'},
    { title: 'Corn', serving: 154, calories: 562, department: 'Produce'},
    { title: 'Courgette', serving: 196, calories: 33, department: 'Produce'},
    { title: 'Creamed Spinach', serving: 200, calories: 148, department: 'Produce'},
    { title: 'Cucumber', serving: 410, calories: 66, department: 'Produce'},
    { title: 'Eggplant', serving: 458, calories: 115, department: 'Produce'},
    { title: 'Endive', serving: 513, calories: 87, department: 'Produce'},
    { title: 'Fennel', serving: 234, calories: 73, department: 'Produce'},
    { title: 'Garlic', serving: 3, calories: 4, department: 'Produce'},
    { title: 'Gherkin', serving: 65, calories: 9, department: 'Produce'},
    { title: 'Goa Beans', department: 'Produce'},
    { title: 'Gourd', serving: 771, calories: 108, department: 'Produce'},
    { title: 'Green Beans', serving: 110, calories: 34, department: 'Produce'},
    { title: 'Green Onion', serving: 15, calories: 5, department: 'Produce'},
    { title: 'Horseradish', serving: 15, calories: 7, department: 'Produce'},
    { title: 'Kale', serving: 67, calories: 33, department: 'Produce'},
    { title: 'Kohlrabi', serving: 400, calories: 108, department: 'Produce'},
    { title: 'Kumara', serving: 130, calories: 112, department: 'Produce'},
    { title: 'Leek', serving: 89, calories: 54, department: 'Produce'},
    { title: 'Lettuce', serving: 600, calories: 90, department: 'Produce'},
    { title: 'Mushrooms', serving: 5.4, calories: 1, department: 'Produce'},
    { title: 'Mustard Greens', serving: 56, calories: 15, department: 'Produce'},
    { title: 'Nori', serving: 2.6, calories: 1, department: 'Produce'},
    { title: 'Okra', serving: 12, calories: 4, department: 'Produce'},
    { title: 'Olives', serving: 2.7, calories: 2, department: 'Produce'},
    { title: 'Onion', serving: 85, calories: 34, department: 'Produce'},
    { title: 'Parsnips', serving: 170, calories: 128, department: 'Produce'},
    { title: 'Peas', serving: 98, calories: 79, department: 'Produce'},
    { title: 'Pepper', serving: 75, calories: 20, department: 'Produce'},
    { title: 'Potato', serving: 213, calories: 164, department: 'Produce'},
    { title: 'Pumpkin', serving: 196, calories: 51, department: 'Produce'},
    { title: 'Radishes', serving: 4.5, calories: 1, department: 'Produce'},
    { title: 'Red Cabbage', serving: 22, calories: 7, department: 'Produce'},
    { title: 'Red Potatoes', department: 'Produce'},
    { title: 'Russet Potatoes', department: 'Produce'},
    { title: 'Rutabaga', serving: 386, calories: 147, department: 'Produce'},
    { title: 'Shallots', serving: 25, calories: 18, department: 'Produce'},
    { title: 'Spinach', serving: 340, calories: 78, department: 'Produce'},
    { title: 'Squash', serving: 196, calories: 88, department: 'Produce'},
    { title: 'Sweet Potato', serving: 130, calories: 112, department: 'Produce'},
    { title: 'Tomato', serving: 111, calories: 20, department: 'Produce'},
    { title: 'Turnip Greens', serving: 170, calories: 34, department: 'Produce'},
    { title: 'Turnips', serving: 122, calories: 34, department: 'Produce'},
    { title: 'Wasabi', serving: 169, calories: 184, department: 'Produce'},
    { title: 'White Potatoes', department: 'Produce'},
    { title: 'Winter Squash', serving: 431, calories: 147, department: 'Produce'},
    { title: 'Yukon Gold Potatoes', department: 'Produce'},
    { title: 'Zucchini', serving: 196, calories: 33, department: 'Produce'},
    { title: 'Cauliflower Rice', department: 'Produce'},

    // Fruits (g)
    { title: 'Acai', serving: 28.4, calories: 20, department: 'Produce'},
    { title: 'Acelora', serving: 4.8, calories: 1, department: 'Produce'},
    { title: 'Apple', serving: 182, calories: 95, department: 'Produce'},
    { title: 'Apricot', serving: 35, calories: 17, department: 'Produce'},
    { title: 'Asian Pear', serving: 178, calories: 75, department: 'Produce'},
    { title: 'Avocado', serving: 200, calories: 320, department: 'Produce'},
    { title: 'Banana', serving: 125, calories: 111, department: 'Produce'},
    { title: 'Blackberries', serving: 144, calories: 62, department: 'Produce'},
    { title: 'Blood Oranges', serving: 140, calories: 70, department: 'Produce'},
    { title: 'Blueberries', serving: 148, calories: 84, department: 'Produce'},
    { title: 'Breadfruit', serving: 96, calories: 99, department: 'Produce'},
    { title: 'Cantaloupe', serving: 69, calories: 23, department: 'Produce'},
    { title: 'Casaba Melon', serving: 125, calories: 35, department: 'Produce'},
    { title: 'Cherimoya', serving: 235, calories: 176, department: 'Produce'},
    { title: 'Cherries', serving: 8, calories: 4, department: 'Produce'},
    { title: 'Clementine', serving: 74, calories: 35, department: 'Produce'},
    { title: 'Cranberries', serving: 100, calories: 46, department: 'Produce'},
    { title: 'Currants', serving: 112, calories: 63, department: 'Produce'},
    { title: 'Custard Apple', serving: 135, calories: 136, department: 'Produce'},
    { title: 'Dates', serving: 7.1, calories: 20, department: 'Produce'},
    { title: 'Dragon Fruit', serving: 200, calories: 120, department: 'Produce'},
    { title: 'Durian', serving: 602, calories: 885, department: 'Produce'},
    { title: 'Feijoa', serving: 42, calories: 23, department: 'Produce'},
    { title: 'Figs', serving: 50, calories: 37, department: 'Produce'},
    { title: 'Galia Melon', serving: 130, calories: 30, department: 'Produce'},
    { title: 'Grapefruit', serving: 123, calories: 52, department: 'Produce'},
    { title: 'Grapes', serving: 151, calories: 104, department: 'Produce'},
    { title: 'Greengage', serving: 5, calories: 2, department: 'Produce'},
    { title: 'Guava', serving: 55, calories: 37, department: 'Produce'},
    { title: 'Honeydew', serving: 125, calories: 45, department: 'Produce'},
    { title: 'Jackfruit', serving: 151, calories: 143, department: 'Produce'},
    { title: 'Jujube', serving: 28.4, calories: 22, department: 'Produce'},
    { title: 'Kiwi', serving: 183, calories: 112, department: 'Produce'},
    { title: 'Kumquat', serving: 19, calories: 13, department: 'Produce'},
    { title: 'Lemon', serving: 58, calories: 17, department: 'Produce'},
    { title: 'Lime', serving: 67, calories: 20, department: 'Produce'},
    { title: 'Lychee', serving: 10, calories: 7, department: 'Produce'},
    { title: 'Mandarin Oranges', serving: 88, calories: 47, department: 'Produce'},
    { title: 'Mango', serving: 336, calories: 202, department: 'Produce'},
    { title: 'Mangosteen', serving: 80, calories: 58, department: 'Produce'},
    { title: 'Maracuya', serving: 18, calories: 17, department: 'Produce'},
    { title: 'Maraschino Cherries', serving: 5, calories: 8, department: 'Produce'},
    { title: 'Minneola', serving: 109, calories: 70, department: 'Produce'},
    { title: 'Mulberries', serving: 140, calories: 60, department: 'Produce'},
    { title: 'Muskmelon', serving: 69, calories: 23, department: 'Produce'},
    { title: 'Napa Cabbage', department: 'Produce'},
    { title: 'Nectarine', serving: 150, calories: 66, department: 'Produce'},
    { title: 'Noni', serving: 28.4, calories: 15, department: 'Produce'},
    { title: 'Orange', serving: 131, calories: 62, department: 'Produce'},
    { title: 'Papaya', serving: 500, calories: 215, department: 'Produce'},
    { title: 'Passion Fruit', serving: 18, calories: 17, department: 'Produce'},
    { title: 'Peach', serving: 150, calories: 59, department: 'Produce'},
    { title: 'Pear', serving: 178, calories: 101, department: 'Produce'},
    { title: 'Persimmon', serving: 25, calories: 32, department: 'Produce'},
    { title: 'Pineapple', serving: 905, calories: 453, department: 'Produce'},
    { title: 'Pink Grapefruit', serving: 123, calories: 52, department: 'Produce'},
    { title: 'Plantain', serving: 179, calories: 218, department: 'Produce'},
    { title: 'Plum', serving: 66, calories: 30, department: 'Produce'},
    { title: 'Pomegranate', serving: 282, calories: 234, department: 'Produce'},
    { title: 'Pomelo', serving: 609, calories: 231, department: 'Produce'},
    { title: 'Prickly Pear', serving: 19, calories: 8, department: 'Produce'},
    { title: 'Quince', serving: 92, calories: 52, department: 'Produce'},
    { title: 'Raisins', serving: 145, calories: 434, department: 'Produce'},
    { title: 'Rambutan', serving: 9, calories: 7, department: 'Produce'},
    { title: 'Raspberries', serving: 123, calories: 64, department: 'Produce'},
    { title: 'Rhubarb', serving: 51, calories: 11, department: 'Produce'},
    { title: 'Sapodilla', serving: 170, calories: 141, department: 'Produce'},
    { title: 'Soursop Fruit', serving: 625, calories: 413, department: 'Produce'},
    { title: 'Starfruit', serving: 91, calories: 28, department: 'Produce'},
    { title: 'Strawberries', serving: 152, calories: 49, department: 'Produce'},
    { title: 'Tangerine', serving: 88, calories: 47, department: 'Produce'},
    { title: 'Tamarind', serving: 2, calories: 5, department: 'Produce'},
    { title: 'Watermelon', serving: 286, calories: 86, department: 'Produce'},

    // Pork
    { title: 'Bacon', serving: 26, calories: 106, department: 'Meat'},
    { title: 'Brawn', serving: 25, calories: 77, department: 'Meat'},
    { title: 'Canadian-Style Bacon', serving: 56, calories: 60, department: 'Meat'},
    { title: 'Chitterling', serving: 85, calories: 198, department: 'Meat'},
    { title: 'Ground Pork', serving: 112, calories: 295, department: 'Meat'},
    { title: 'Meatloaf', serving: 336, calories: 299, department: 'Meat'},
    { title: 'Pork Baby Back Rib', serving: 70, calories: 148, department: 'Meat'},
    { title: 'Pork Belly', serving: 28, calories: 145, department: 'Meat'},
    { title: 'Pork Blade Steak', serving: 113, calories: 262, department: 'Meat'},
    { title: 'Pork Chop', serving: 158, calories: 194, department: 'Meat'},
    { title: 'Pork Country-Style Rib', serving: 113, calories: 150, department: 'Meat'},
    { title: 'Pork Crown Roast', serving: 113, calories: 240, department: 'Meat'},
    { title: 'Pork Cutlet', serving: 283, calories: 371, department: 'Meat'},
    { title: 'Pork Leg', serving: 231, calories: 464, department: 'Meat'},
    { title: 'Pork Loin', serving: 333, calories: 476, department: 'Meat'},
    { title: 'Pork Meatloaf', serving: 113, calories: 275, department: 'Meat'},
    { title: 'Pork Ragout', serving: 361, calories: 264, department: 'Meat'},
    { title: 'Pork Rib Roast', serving: 113, calories: 180, department: 'Meat'},
    { title: 'Pork Ribs', serving: 85, calories: 248, department: 'Meat'},
    { title: 'Pork Roast', serving: 263, calories: 510, department: 'Meat'},
    { title: 'Pork Sausage', serving: 48, calories: 163, department: 'Meat'},
    { title: 'Pork Shank', serving: 28, calories: 48, department: 'Meat'},
    { title: 'Pork Shoulder', serving: 262, calories: 705, department: 'Meat'},
    { title: 'Pork Shoulder Blade', serving: 113, calories: 262, department: 'Meat'},
    { title: 'Pork Steak', serving: 264, calories: 517, department: 'Meat'},
    { title: 'Pork Stomach', serving: 28, calories: 70, department: 'Meat'},
    { title: 'Rack of Pork', serving: 113, calories: 272, department: 'Meat'},
    { title: 'Salt Pork', serving: 28, calories: 80, department: 'Meat'},
    { title: 'Serrano Ham', serving: 56, calories: 190, department: 'Meat'},
    { title: 'Spare Rib', serving: 85, calories: 337, department: 'Meat'},

    // Poultry&Fowl
    { title: 'Whole Chicken', serving: 668, calories: 1462, department: 'Meat'},
    { title: 'Chicken Breast', serving: 200, calories: 344, department: 'Meat'},
    { title: 'Chicken Drumsticks', serving: 71, calories: 131, department: 'Meat'},
    { title: 'Chicken Fat', serving: 205, calories: 1841, department: 'Meat'},
    { title: 'Chicken Giblets', serving: 145, calories: 229, department: 'Meat'},
    { title: 'Chicken Gizzards', serving: 145, calories: 223, department: 'Meat'},
    { title: 'Chicken Leg', serving: 199, calories: 346, department: 'Meat'},
    { title: 'Chicken Liver', serving: 44, calories: 73, department: 'Meat'},
    { title: 'Chicken Thigh', serving: 111, calories: 254, department: 'Meat'},
    { title: 'Chicken Wing', serving: 53, calories: 141, department: 'Meat'},
    { title: 'Duck', serving: 634, calories: 2137, department: 'Meat'},
    { title: 'Duck Breast', serving: 73, calories: 147, department: 'Meat'},
    { title: 'Turkey', serving: 3812, calories: 7205, department: 'Meat'},
    { title: 'Turkey Breast', serving: 864, calories: 1166, department: 'Meat'},
    { title: 'Turkey Cutlet', serving: 113, calories: 214, department: 'Meat'},
    { title: 'Turkey Drumsticks', serving: 100, calories: 208, department: 'Meat'},
    { title: 'Turkey Legs', serving: 546, calories: 1136, department: 'Meat'},
    { title: 'Turkey Steak', serving: 170, calories: 321, department: 'Meat'},
    { title: 'Turkey Wings', serving: 24, calories: 53, department: 'Meat'},

    // Beef
    { title: 'Beef', serving: 164, calories: 407, department: 'Meat'},
    { title: 'Beef Brisket', serving: 1780, calories: 4308, department: 'Meat'},
    { title: 'Beef Fillet', serving: 168, calories: 318, department: 'Meat'},
    { title: 'Beef Goulash', serving: 227, calories: 279, department: 'Meat'},
    { title: 'Beef Jerky', serving: 20, calories: 82, department: 'Meat'},
    { title: 'Beef Minute Steak', serving: 168, calories: 223, department: 'Meat'},
    { title: 'Beef Neck', serving: 224, calories: 477, department: 'Meat'},
    { title: 'Beef Patty', serving: 64, calories: 158, department: 'Meat'},
    { title: 'Beef Prime Rib', serving: 278, calories: 1123, department: 'Meat'},
    { title: 'Beef Rib', serving: 225, calories: 536, department: 'Meat'},
    { title: 'Beef Sirloin', serving: 85, calories: 155, department: 'Meat'},
    { title: 'Beef Suet', serving: 28, calories: 239, department: 'Meat'},
    { title: 'Beef Tallow', serving: 205, calories: 1849, department: 'Meat'},
    { title: 'Beef Tenderloin', serving: 140, calories: 305, department: 'Meat'},
    { title: 'Beef Thymus', serving: 381, calories: 1215, department: 'Meat'},
    { title: 'Beef Tripe', serving: 85, calories: 80, department: 'Meat'},
    { title: 'Chuck Steak', serving: 310, calories: 859, department: 'Meat'},
    { title: 'Cubed Steak', serving: 165, calories: 328, department: 'Meat'},
    { title: 'Filet Mignon', serving: 104, calories: 278, department: 'Meat'},
    { title: 'Flank Steak', serving: 188, calories: 365, department: 'Meat'},
    { title: 'Flat Iron Steak', serving: 252, calories: 345, department: 'Meat'},
    { title: 'Ground Beef', serving: 70, calories: 172, department: 'Meat'},
    { title: 'Ground Chuck', serving: 168, calories: 420, department: 'Meat'},
    { title: 'Ground Round', serving: 113, calories: 278, department: 'Meat'},
    { title: 'Ham', serving: 145, calories: 236, department: 'Meat'},
    { title: 'New York Strip Steak', serving: 214, calories: 426, department: 'Meat'},
    { title: 'Porterhouse Steak', serving: 320, calories: 790, department: 'Meat'},
    { title: 'Rib Eye Steak', serving: 281, calories: 610, department: 'Meat'},
    { title: 'Roast Beef', serving: 515, calories: 721, department: 'Meat'},
    { title: 'Round Steak', serving: 236, calories: 430, department: 'Meat'},
    { title: 'Rump Steak', serving: 205, calories: 351, department: 'Meat'},
    { title: 'Schnitzel', serving: 130, calories: 203, department: 'Meat'},
    { title: 'Skirt Steak', serving: 168, calories: 344, department: 'Meat'},
    { title: 'Standing Rib Roast', serving: 113, calories: 376, department: 'Meat'},
    { title: 'Stew Beef', serving: 454, calories: 867, department: 'Meat'},
    { title: 'Strip Steak', serving: 34, calories: 40, department: 'Meat'},
    { title: 'T-Bone Steak', serving: 287, calories: 580, department: 'Meat'},

    // Sausage
    { title: 'Andouille', serving: 85, calories: 197, department: 'Meat'},
    { title: 'Black Pudding', serving: 25, calories: 95, department: 'Meat'},
    { title: 'Blood Sausage', serving: 25, calories: 95, department: 'Meat'},
    { title: 'Bockwurst', serving: 91, calories: 274, department: 'Meat'},
    { title: 'Boudin', serving: 28.4, calories: 54, department: 'Meat'},
    { title: 'Breakfast Sausage', serving: 13, calories: 44, department: 'Meat'},
    { title: 'Chicken Salad', serving: 344, calories: 279, department: 'Meat'},
    { title: 'Chorizo', serving: 28.4, calories: 127, department: 'Meat'},
    { title: 'Cooked Ham', serving: 28.4, calories: 37, department: 'Meat'},
    { title: 'Corned Beef', serving: 28, calories: 43, department: 'Meat'},
    { title: 'Frankfruters', serving: 45, calories: 137, department: 'Meat'},
    { title: 'Garlic Sausage', serving: 13, calories: 22, department: 'Meat'},
    { title: 'Hot Dogs', serving: 52, calories: 145, department: 'Meat'},
    { title: 'Hot Sausage', serving: 55, calories: 142, department: 'Meat'},
    { title: 'Italian Sausage', serving: 84, calories: 125, department: 'Meat'},
    { title: 'Jerky', serving: 20, calories: 82, department: 'Meat'},
    { title: 'Liver Pate', serving: 13, calories: 41, department: 'Meat'},
    { title: 'Luncheon Meat', serving: 9.3, calories: 11, department: 'Meat'},
    { title: 'Polish Sausage', serving: 76, calories: 229, department: 'Meat'},
    { title: 'Pork Roll', serving: 43, calories: 130, department: 'Meat'},
    { title: 'Salami', serving: 12.3, calories: 40, department: 'Meat'},
    { title: 'Sausage', serving: 16, calories: 37, department: 'Meat'},
    { title: 'Smoked Sausage', serving: 76, calories: 229, department: 'Meat'},
    { title: 'Spam', serving: 56, calories: 176, department: 'Meat'},



    // Seafood
    { title: 'Anchovy', serving: 85, calories: 111, department: 'Seafood'},
    { title: 'Albacore', department: 'Seafood'},
    { title: 'Bluefish', serving: 117, calories: 186, department: 'Seafood'},
    { title: 'Bream', serving: 125, calories: 169, department: 'Seafood'},
    { title: 'Butterfish', serving: 25, calories: 47, department: 'Seafood'},
    { title: 'Calamari', serving: 12, calories: 21, department: 'Seafood'},
    { title: 'Carp', serving: 170, calories: 275, department: 'Seafood'},
    { title: 'Caviar', serving: 16, calories: 42, department: 'Seafood'},
    { title: 'Clam', serving: 85, calories: 126, department: 'Seafood'},
    { title: 'Cod', serving: 180, calories: 189, department: 'Seafood'},
    { title: 'Crawfish', serving: 12, calories: 10, department: 'Seafood'},
    { title: 'Crayfish', serving: 85, calories: 74, department: 'Seafood'},
    { title: 'Eel', serving: 28.4, calories: 66, department: 'Seafood'},
    { title: 'Fish Fingers', serving: 28, calories: 81, department: 'Seafood'},
    { title: 'Fish Sticks', serving: 28, calories: 81, department: 'Seafood'},
    { title: 'Flounder', serving: 127, calories: 109, department: 'Seafood'},
    { title: 'Grouper', serving: 202, calories: 238, department: 'Seafood'},
    { title: 'Haddock', serving: 150, calories: 135, department: 'Seafood'},
    { title: 'Hake', serving: 113, calories: 80, department: 'Seafood'},
    { title: 'Halibut', serving: 200, calories: 222, department: 'Seafood'},
    { title: 'Herring', serving: 143, calories: 290, department: 'Seafood'},
    { title: 'Hoki', serving: 70, calories: 85, department: 'Seafood'},
    { title: 'Kipper', serving: 40, calories: 87, department: 'Seafood'},
    { title: 'Ling', serving: 151, calories: 165, department: 'Seafood'},
    { title: 'Lobster', serving: 150, calories: 134, department: 'Seafood'},
    { title: 'Mackerel', serving: 88, calories: 231, department: 'Seafood'},
    { title: 'Milkfish', serving: 85, calories: 162, department: 'Seafood'},
    { title: 'Monkfish', serving: 85, calories: 82, department: 'Seafood'},
    { title: 'Mullet', serving: 93, calories: 140, department: 'Seafood'},
    { title: 'Mussel', serving: 85, calories: 146, department: 'Seafood'},
    { title: 'Octopus', serving: 85, calories: 139, department: 'Seafood'},
    { title: 'Pickerel', serving: 127, calories: 141, department: 'Seafood'},
    { title: 'Pickled Herring', serving: 140, calories: 367, department: 'Seafood'},
    { title: 'Pike', serving: 155, calories: 175, department: 'Seafood'},
    { title: 'Plaice', serving: 100, calories: 91, department: 'Seafood'},
    { title: 'Pollack', serving: 151, calories: 168, department: 'Seafood'},
    { title: 'Red Snapper', serving: 170, calories: 218, department: 'Seafood'},
    { title: 'Redfish', serving: 57, calories: 54, department: 'Seafood'},
    { title: 'Rollmops', serving: 65, calories: 111, department: 'Seafood'},
    { title: 'Salmon', serving: 178, calories: 367, department: 'Seafood'},
    { title: 'Sardines', serving: 149, calories: 310, department: 'Seafood'},
    { title: 'Scallops', serving: 10, calories: 11, department: 'Seafood'},
    { title: 'Scampi', serving: 10, calories: 8, department: 'Seafood'},
    { title: 'Sea Bass', serving: 124, calories: 154, department: 'Seafood'},
    { title: 'Shad', serving: 144, calories: 363, department: 'Seafood'},
    { title: 'Shark', serving: 85, calories: 111, department: 'Seafood'},
    { title: 'Smelt', serving: 85, calories: 105, department: 'Seafood'},
    { title: 'Sole', serving: 127, calories: 109, department: 'Seafood'},
    { title: 'Squid', serving: 28.4, calories: 26, department: 'Seafood'},
    { title: 'Sturgeaon', serving: 136, calories: 184, department: 'Seafood'},
    { title: 'Swordfish', serving: 106, calories: 182, department: 'Seafood'},
    { title: 'Triggerfish', serving: 28.4, calories: 26, department: 'Seafood'},
    { title: 'Trout', serving: 62, calories: 118, department: 'Seafood'},
    { title: 'Tuna', serving: 154, calories: 203, department: 'Seafood'},
    { title: 'Turbot', serving: 159, calories: 194, department: 'Seafood'},
    { title: 'Wahoo', serving: 100, calories: 167, department: 'Seafood'},
    { title: 'Whitefish', serving: 154, calories: 265, department: 'Seafood'},
    { title: 'Whiting', serving: 72, calories: 84, department: 'Seafood'},
    { title: 'Yellowfin Tuna', department: 'Seafood'},
    { title: 'Zander', serving: 62, calories: 52, department: 'Seafood'},
    { title: 'Cod Roe', department: 'Seafood'},
    { title: 'Masago', department: 'Seafood'},
    { title: 'Ikura (Salmon Roe)', department: 'Seafood'},

    // Pasta/Noodles
    { title: 'Cannelloni', serving: 56, calories: 82, department: 'Pantry'},
    { title: 'Capellini', serving: 56, calories: 198, department: 'Pantry'},
    { title: 'Capelletti', serving: 56, calories: 92, department: 'Pantry'},
    { title: 'Glass Noodles', serving: 140, calories: 491, department: 'Pantry'},
    { title: 'Cheese Tortellini', serving: 113, calories: 329, department: 'Pantry'},
    { title: 'Dumpling DOugh', serving: 56, calories: 55, department: 'Pantry'},
    { title: 'Durum Wheat Semolina', serving: 56, calories: 222, department: 'Pantry'},
    { title: 'Egg Noodles', serving: 38, calories: 146, department: 'Pantry'},
    { title: 'Farfalle', serving: 56, calories: 200, department: 'Pantry'},
    { title: 'Fettuccine', serving: 56, calories: 198, department: 'Pantry'},
    { title: 'Fusilli', serving: 56, calories: 197, department: 'Pantry'},
    { title: 'Lasagne Sheets', serving: 21, calories: 57, department: 'Pantry'},
    { title: 'Linguine', serving: 56, calories: 200, department: 'Pantry'},
    { title: 'Low Carb Pasta', serving: 56, calories: 158, department: 'Pantry'},
    { title: 'Macaroni', serving: 114, calories: 422, department: 'Pantry'},
    { title: 'Manicotti', serving: 56, calories: 200, department: 'Pantry'},
    { title: 'Mostaccioli', serving: 56, calories: 103, department: 'Pantry'},
    { title: 'Orecchiette', serving: 56, calories: 207, department: 'Pantry'},
    { title: 'Orzo', serving: 56, calories: 200, department: 'Pantry'},
    { title: 'Penne', serving: 56, calories: 197, department: 'Pantry'},
    { title: 'Penne Rigate', serving: 56, calories: 207, department: 'Pantry'},
    { title: 'Pierogi', serving: 100, calories: 200, department: 'Pantry'},
    { title: 'Ravioli', serving: 56, calories: 43, department: 'Pantry'},
    { title: 'Rigatoni', serving: 56, calories: 198, department: 'Pantry'},
    { title: 'Rotini', serving: 56, calories: 198, department: 'Pantry'},
    { title: 'Shells', serving: 85, calories: 300, department: 'Pantry'},
    { title: 'Shirataki Noodles', serving: 56, calories: 10, department: 'Pantry'},
    { title: 'Soy Noodles', serving: 56, calories: 121, department: 'Pantry'},
    { title: 'Spaetzle', serving: 56, calories: 206, department: 'Pantry'},
    { title: 'Spaghetti', serving: 56, calories: 207, department: 'Pantry'},
    { title: 'Spinach Torellini', serving: 102, calories: 320, department: 'Pantry'},
    { title: 'Spirelli', serving: 56, calories: 206, department: 'Pantry'},
    { title: 'Tagliatelle', serving: 56, calories: 207, department: 'Pantry'},
    { title: 'Tortellini', serving: 113, calories: 329, department: 'Pantry'},
    { title: 'Vermicelli', serving: 56, calories: 206, department: 'Pantry'},
    { title: 'Whole Grain Noodles', serving: 56, calories: 194, department: 'Pantry'},
    { title: 'Whole Grain Spaghetti', serving: 56, calories: 197, department: 'Pantry'},
    { title: 'Ziti', serving: 56, calories: 197, department: 'Pantry'},



    // Vegetable Oils (unit: ml/g)
    { title: 'Almond Oil', serving: 14, calories: 123, department: 'Pantry'},
    { title: 'Apricot Kernel Oil', serving: 14, calories: 124, department: 'Pantry'},
    { title: 'Argan Oil', serving: 14, calories: 125, department: 'Pantry'},
    { title: 'Avocado Oil', serving: 14, calories: 120, department: 'Pantry'},
    { title: 'Babassu Oil', serving: 14, calories: 124, department: 'Pantry'},
    { title: 'Butter', serving: 15, calories: 108, department: 'Pantry'},
    { title: 'Canola Oil', serving: 14, calories: 124, department: 'Pantry'},
    { title: 'Coconut Oil', serving: 14, calories: 120, department: 'Pantry'},
    { title: 'Cod Liver Oil', serving: 14, calories: 140, department: 'Pantry'},
    { title: 'Corn Oil', serving: 15, calories: 120, department: 'Pantry'},
    { title: 'Cottonseed Oil', serving: 14, calories: 123, department: 'Pantry'},
    { title: 'Flaxseed Oil', serving: 14, calories: 124, department: 'Pantry'},
    { title: 'Ghee', serving: 14, calories: 17, department: 'Pantry'},
    { title: 'Goose Fat', serving: 13, calories: 117, department: 'Pantry'},
    { title: 'Grape Seed Oil', serving: 14, calories: 124, department: 'Pantry'},
    { title: 'Hazelnut Oil', serving: 14, calories: 124, department: 'Pantry'},
    { title: 'Hemp Oil', serving: 15, calories: 121, department: 'Pantry'},
    { title: 'Herring Oil', serving: 14, calories: 126, department: 'Pantry'},
    { title: 'Lard', serving: 13, calories: 117, department: 'Pantry'},
    { title: 'Linseed Oil', serving: 14, calories: 117, department: 'Pantry'},
    { title: 'Macadamia Oil', serving: 14, calories: 115, department: 'Pantry'},
    { title: 'Margarine', serving: 14, calories: 100, department: 'Pantry'},
    { title: 'Menhaden Oil', serving: 14, calories: 128, department: 'Pantry'},
    { title: 'Mustard Oil', serving: 14, calories: 124, department: 'Pantry'},
    { title: 'Oat Oil', serving: 14, calories: 124, department: 'Pantry'},
    { title: 'Olive Oil', serving: 15, calories: 120, department: 'Pantry'},
    { title: 'Palm Kernel Oil', serving: 14, calories: 123, department: 'Pantry'},
    { title: 'Palm Oil', serving: 14, calories: 123, department: 'Pantry'},
    { title: 'Peanut Oil', serving: 14, calories: 120, department: 'Pantry'},
    { title: 'Poppy Seed Oil', serving: 14, calories: 124, department: 'Pantry'},
    { title: 'Pumpkin Seed Oil', serving: 14, calories: 123, department: 'Pantry'},
    { title: 'Real Butter', serving: 15, calories: 108, department: 'Pantry'},
    { title: 'Rice Bran Oil', serving: 14, calories: 124, department: 'Pantry'},
    { title: 'Safflower Oil', serving: 14, calories: 120, department: 'Pantry'},
    { title: 'Salmon Oil', serving: 14, calories: 128, department: 'Pantry'},
    { title: 'Sardine Oil', serving: 14, calories: 126, department: 'Pantry'},
    { title: 'Sesame Oil', serving: 14, calories: 124, department: 'Pantry'},
    { title: 'Shea Oil', serving: 14, calories: 124, department: 'Pantry'},
    { title: 'Soybean Oil', serving: 14, calories: 124, department: 'Pantry'},
    { title: 'Sunflower Oil', serving: 14, calories: 124, department: 'Pantry'},
    { title: 'Tomato Seed Oil', serving: 14, calories: 124, department: 'Pantry'},
    { title: 'Vegetable Oil', serving: 15, calories: 120, department: 'Pantry'},
    { title: 'Walnut Oil', serving: 14, calories: 124, department: 'Pantry'},
    { title: 'Wheat Germ Oil', serving: 14, calories: 130, department: 'Pantry'},

    // Spreads
    { title: 'Almond Butter', serving: 16, calories: 98, department: 'Pantry'},
    { title: 'Apple Butter', serving: 17, calories: 29, department: 'Pantry'},
    { title: 'Applesauce', serving: 255, calories: 173, department: 'Pantry'},
    { title: 'Apricot Jam', serving: 20, calories: 50, department: 'Pantry'},
    { title: 'Blackberry Jam', serving: 20, calories: 50, department: 'Pantry'},
    { title: 'Blackcurrant Jam', serving: 20, calories: 50, department: 'Pantry'},
    { title: 'Blueberry Jam', serving: 20, calories: 50, department: 'Pantry'},
    { title: 'Cherry Jam', serving: 20, calories: 50, department: 'Pantry'},
    { title: 'Chocolate Spread', serving: 12, calories: 65, department: 'Pantry'},
    { title: 'Cream Cheese', serving: 232, calories: 793, department: 'Pantry'},
    { title: 'Grape Jelly', serving: 20, calories: 51, department: 'Pantry'},
    { title: 'Honey', serving: 21, calories: 64, department: 'Pantry'},
    { title: 'Jelly', serving: 20, calories: 56, department: 'Pantry'},
    { title: 'Jif Peanut Butter', serving: 16, calories: 93, department: 'Pantry'},
    { title: 'Marmite', serving: 4, calories: 9, department: 'Pantry'},
    { title: 'Marshmallow Fluff', serving: 6, calories: 40, department: 'Pantry'},
    { title: 'Nutella', serving: 15, calories: 82, department: 'Pantry'},
    { title: 'Peanut Butter', serving: 16, calories: 94, department: 'Pantry'},
    { title: 'Plum Jam', serving: 20, calories: 50, department: 'Pantry'},
    { title: 'Pate', serving: 13, calories: 41, department: 'Pantry'},
    { title: 'Salted Butter', serving: 227, calories: 1628, department: 'Pantry'},
    { title: 'Strawberry Jam', serving: 20, calories: 50, department: 'Pantry'},
    { title: 'Strawberry Jelly', serving: 20, calories: 50, department: 'Pantry'},
    { title: 'Sunbutter', serving: 16, calories: 99, department: 'Pantry'},
    { title: 'Sunflower Butter', serving: 227, calories: 1401, department: 'Pantry'},
    { title: 'Unsalted Butter', serving: 227, calories: 1628, department: 'Pantry'},
    { title: 'Vegemite', serving: 5, calories: 9, department: 'Pantry'},
    { title: 'Wild Honey', serving: 21, calories: 60, department: 'Pantry'},

    // Milk/Dairy Products (g/ml)
    { title: 'Almond Milk', serving: 235, calories: 40, department: 'Dairy'},
    { title: 'Buttermilk', serving: 254, calories: 157, department: 'Dairy'},
    { title: 'Chocolate Mousse', serving: 202, calories: 455, department: 'Dairy'},
    { title: 'Coconut Milk', serving: 240, calories: 552, department: 'Dairy'},
    { title: 'Coffee Creamer', serving: 15, calories: 29, department: 'Dairy'},
    { title: 'Condensed Milk', serving: 306, calories: 982, department: 'Dairy'},
    { title: 'Cottage Cheese', serving: 210, calories: 206, department: 'Dairy'},
    { title: 'Cream', serving: 15, calories: 36, department: 'Dairy'},
    { title: 'Curd', serving: 210, calories: 206, department: 'Dairy'},
    { title: 'Custard', serving: 141, calories: 172, department: 'Dairy'},
    { title: 'Egg', department: 'Dairy'},
    { title: 'Evaporated Milk', serving: 252, calories: 340, department: 'Dairy'},
    { title: 'Goat Milk', serving: 244, calories: 168, department: 'Dairy'},
    { title: 'Lactose-free Milk', serving: 250, calories: 130, department: 'Dairy'},
    { title: 'Milk', serving: 244, calories: 149, department: 'Dairy'},
    { title: 'Rice Milk', serving: 245, calories: 120, department: 'Dairy'},
    { title: 'Rice Pudding', serving: 113, calories: 133, department: 'Dairy'},
    { title: 'Semi-skimmed Milk', serving: 250, calories: 125, department: 'Dairy'},
    { title: 'Skim Milk', serving: 247, calories: 86, department: 'Dairy'},
    { title: 'Sour Cream', serving: 12, calories: 22, department: 'Dairy'},
    { title: 'Soy Milk', serving: 243, calories: 109, department: 'Dairy'},
    { title: 'Sweetened Condensed Milk', serving: 306, calories: 982, department: 'Dairy'},
    { title: 'Whipped Cream', serving: 3, calories: 8, department: 'Dairy'},
    { title: 'Whole Milk', serving: 244, calories: 149, department: 'Dairy'},
    { title: 'Yogurt', serving: 227, calories: 138, department: 'Dairy'},



    // Ice Cream
    { title: 'Butter Pecan Ice Cream', department: 'Dairy'},
    { title: 'Chocolate Chip Ice Cream', department: 'Dairy'},
    { title: 'Chocolate Ice Cream', department: 'Dairy'},
    { title: 'Coffee Ice Cream', department: 'Dairy'},
    { title: 'Cookie Dough Ice Cream', department: 'Dairy'},
    { title: 'Mint Chocolate Chip Ice Cream', department: 'Dairy'},
    { title: 'Rocky Road Ice Cream', department: 'Dairy'},
    { title: 'Strawberry Ice Cream', department: 'Dairy'},
    { title: 'Vanilla Ice Cream', department: 'Dairy'},
    { title: 'Soft Serve', department: 'Dairy'},




    // Plant Products
    { title: 'Azuki Bean', department: 'Pantry'},
    { title: 'Bamboo Shoots', department: 'Pantry'},
    { title: 'Bean Curd', department: 'Pantry'},
    { title: 'Black Beans', department: 'Pantry'},
    { title: 'Black Chickpeas', department: 'Pantry'},
    { title: 'Brown Lentil', department: 'Pantry'},
    { title: 'Butternut', department: 'Pantry'},
    { title: 'Chickpeas', department: 'Pantry'},
    { title: 'Chili Beans', department: 'Pantry'},
    { title: 'Dal', department: 'Pantry'},
    { title: 'Deep-Fried Tofu', department: 'Pantry'},
    { title: 'Extra-Firm Tofu', department: 'Pantry'},
    { title: 'Firm Tofu', department: 'Pantry'},
    { title: 'Flageolet', department: 'Pantry'},
    { title: 'Fried Bean Curd', department: 'Pantry'},
    { title: 'Green Chickpeas', department: 'Pantry'},
    { title: 'Green Lentil', department: 'Pantry'},
    { title: 'Kidney Beans', department: 'Pantry'},
    { title: 'Lentils', department: 'Pantry'},
    { title: 'Lima Beans', department: 'Pantry'},
    { title: 'Marron', department: 'Pantry'},
    { title: 'Miso', department: 'Pantry'},
    { title: 'Mung Beans', department: 'Pantry'},
    { title: 'Natto', department: 'Pantry'},
    { title: 'Navy Beans', department: 'Pantry'},
    { title: 'Okara', department: 'Pantry'},
    { title: 'Pecans', department: 'Pantry'},
    { title: 'Pinto Beans', department: 'Pantry'},
    { title: 'Puy Lentils', department: 'Pantry'},
    { title: 'Red Beans', department: 'Pantry'},
    { title: 'Red Kidney Beans', department: 'Pantry'},
    { title: 'Red Lentils', department: 'Pantry'},
    { title: 'Refried Beans', department: 'Pantry'},
    { title: 'Roasted Soybeans', department: 'Pantry'},
    { title: 'Silken Tofu', department: 'Pantry'},
    { title: 'Soft Tofu', department: 'Pantry'},
    { title: 'Soy Cheese', department: 'Pantry'},
    { title: 'Soybeans', department: 'Pantry'},
    { title: 'Sugar Peas', department: 'Pantry'},
    { title: 'Sweet Peas', department: 'Pantry'},
    { title: 'Tofu', department: 'Pantry'},
    { title: 'White Beans', department: 'Pantry'},
    { title: 'Yam Beans', department: 'Pantry'},
    { title: 'Yellow Lentils', department: 'Pantry'},
    { title: 'Yuba', department: 'Pantry'},



    // Nuts & Seeds
    { title: 'Acorn', department: 'Pantry'},
    { title: 'Almonds', department: 'Pantry'},
    { title: 'Brazil Nuts', department: 'Pantry'},
    { title: 'Cashew', department: 'Pantry'},
    { title: 'Chestnut', department: 'Pantry'},
    { title: 'Chia Seeds', department: 'Pantry'},
    { title: 'Cotton Seeds', department: 'Pantry'},
    { title: 'Flaxseed', department: 'Pantry'},
    { title: 'Ginkgo Nuts', department: 'Pantry'},
    { title: 'Hazelnut', department: 'Pantry'},
    { title: 'Hickory Nuts', department: 'Pantry'},
    { title: 'Lotus Seed', department: 'Pantry'},
    { title: 'Macadamia Nuts', department: 'Pantry'},
    { title: 'Peanuts', department: 'Pantry'},
    { title: 'Pecan Nuts', department: 'Pantry'},
    { title: 'Pili Nuts', department: 'Pantry'},
    { title: 'Pine Nuts', department: 'Pantry'},
    { title: 'Pistachios', department: 'Pantry'},
    { title: 'Poppy Seeds', department: 'Pantry'},
    { title: 'Pumpkin Seeds', department: 'Pantry'},
    { title: 'Radish Seeds', department: 'Pantry'},
    { title: 'Safflower Seeds', department: 'Pantry'},
    { title: 'Sesame Seeds', department: 'Pantry'},
    { title: 'Smoked Almonds', department: 'Pantry'},
    { title: 'Sunflower Seeds', department: 'Pantry'},
    { title: 'Sweet Chestnut', department: 'Pantry'},
    { title: 'Walnuts', department: 'Pantry'},


    // Cereal Products
    { title: 'Amaranth', department: 'Pantry'},
    { title: 'Barley', department: 'Pantry'},
    { title: 'Barley Groats', department: 'Pantry'},
    { title: 'Brown Rice', department: 'Pantry'},
    { title: 'Basmati Rice', department: 'Pantry'},
    { title: 'Jasmine Rice', department: 'Pantry'},
    { title: 'Buckwheat', department: 'Pantry'},
    { title: 'Buckwheat Groats', department: 'Pantry'},
    { title: 'Corn Waffles', department: 'Pantry'},
    { title: 'Cornmeal', department: 'Pantry'},
    { title: 'Corn Starch', department: 'Pantry'},
    { title: 'Couscous', department: 'Pantry'},
    { title: 'Cracker', department: 'Pantry'},
    { title: 'Freekeh', department: 'Pantry'},
    { title: 'Gluten', department: 'Pantry'},
    { title: 'Grissini', department: 'Pantry'},
    { title: 'Kamut', department: 'Pantry'},
    { title: 'Millet', department: 'Pantry'},
    { title: 'Millet Flour', department: 'Pantry'},
    { title: 'Millet Gruel', department: 'Pantry'},
    { title: 'Oat Bran', department: 'Pantry'},
    { title: 'Pearl Barley', department: 'Pantry'},
    { title: 'Polenta', department: 'Pantry'},
    { title: 'Prawn Crackers', department: 'Pantry'},
    { title: 'Pretzel Sticks', department: 'Pantry'},
    { title: 'Quinoa', department: 'Pantry'},
    { title: 'Rusk', department: 'Pantry'},
    { title: 'Rye Bran', department: 'Pantry'},
    { title: 'Sago', department: 'Pantry'},
    { title: 'Savoury Biscuits', department: 'Pantry'},
    { title: 'Shortbread', department: 'Pantry'},
    { title: 'Spelt', department: 'Pantry'},
    { title: 'Spelt Bran', department: 'Pantry'},
    { title: 'Spelt Semolina', department: 'Pantry'},
    { title: 'Tortilla', department: 'Pantry'},
    { title: 'Tortilla Chips', department: 'Pantry'},
    { title: 'Wheat Bran', department: 'Pantry'},
    { title: 'Wheat Germ', department: 'Pantry'},
    { title: 'Wheat Gluten', department: 'Pantry'},
    { title: 'Wheat Semolina', department: 'Pantry'},
    { title: 'Wheat Starch', department: 'Pantry'},
    { title: 'White Rice', department: 'Pantry'},
    { title: 'Whole Grain Wheat', department: 'Pantry'},
    { title: 'Whole Grain Oat', department: 'Pantry'},



    // Herbs & Spices
    { title: 'Anise', department: 'Pantry'},
    { title: 'Anise Seed', department: 'Pantry'},
    { title: 'Arrowroot', department: 'Pantry'},
    { title: 'Balsamic Vinegar', department: 'Pantry'},
    { title: 'Basil', department: 'Pantry'},
    { title: 'Black Pepper', department: 'Pantry'},
    { title: 'Black Sesame Seeds', department: 'Pantry'},
    { title: 'Broth', department: 'Pantry'},
    { title: 'Capers', department: 'Pantry'},
    { title: 'Caraway Seeds', department: 'Pantry'},
    { title: 'Cardamom', department: 'Pantry'},
    { title: 'Cassava', department: 'Pantry'},
    { title: 'Cayenne Pepper', department: 'Pantry'},
    { title: 'Chicory Greens', department: 'Pantry'},
    { title: 'Chicory Roots', department: 'Pantry'},
    { title: 'Chili', department: 'Pantry'},
    { title: 'Chili Powder', department: 'Pantry'},
    { title: 'Cider Vinegar', department: 'Pantry'},
    { title: 'Cilantro', department: 'Pantry'},
    { title: 'Cinnamon', department: 'Pantry'},
    { title: 'Cloves', department: 'Pantry'},
    { title: 'Coriander', department: 'Pantry'},
    { title: 'Cream of Tartar', department: 'Pantry'},
    { title: 'Cress', department: 'Pantry'},
    { title: 'Crystalized Ginger', department: 'Pantry'},
    { title: 'Cumin', department: 'Pantry'},
    { title: 'Cumin Seed', department: 'Pantry'},
    { title: 'Dandelion', department: 'Pantry'},
    { title: 'Dill', department: 'Pantry'},
    { title: 'Dill Weed', department: 'Pantry'},
    { title: 'Fennel Seed', department: 'Pantry'},
    { title: 'Fenugreek', department: 'Pantry'},
    { title: 'Garlic Powder', department: 'Pantry'},
    { title: 'Garlic Salt', department: 'Pantry'},
    { title: 'Ginger', department: 'Pantry'},
    { title: 'Grape Leaves', department: 'Pantry'},
    { title: 'Ground Ginger', department: 'Pantry'},
    { title: 'Hot Pepper', department: 'Pantry'},
    { title: 'Iodized Salt', department: 'Pantry'},
    { title: 'Jalapeno', department: 'Pantry'},
    { title: 'Juniper', department: 'Pantry'},
    { title: 'Lemon Grass', department: 'Pantry'},
    { title: 'Licorice', department: 'Pantry'},
    { title: 'Maggi', department: 'Pantry'},
    { title: 'Marjoram', department: 'Pantry'},
    { title: 'Minced Onion', department: 'Pantry'},
    { title: 'Mint', department: 'Pantry'},
    { title: 'Mustard Seed', department: 'Pantry'},
    { title: 'Nutmeg', department: 'Pantry'},
    { title: 'Onion Powder', department: 'Pantry'},
    { title: 'Orange Peel', department: 'Pantry'},
    { title: 'Oregano', department: 'Pantry'},
    { title: 'Paprika', department: 'Pantry'},
    { title: 'Parsley', department: 'Pantry'},
    { title: 'Parsnip', department: 'Pantry'},
    { title: 'Poppy Seed', department: 'Pantry'},
    { title: 'Pumpkin Pie Spice', department: 'Pantry'},
    { title: 'Red Pepper', department: 'Pantry'},
    { title: 'Red Wine Vinegar', department: 'Pantry'},
    { title: 'Rosemary', department: 'Pantry'},
    { title: 'Saffron', department: 'Pantry'},
    { title: 'Sage', department: 'Pantry'},
    { title: 'Salt', department: 'Pantry'},
    { title: 'Savory', department: 'Pantry'},
    { title: 'Sea Salt', department: 'Pantry'},
    { title: 'Serrano Pepper', department: 'Pantry'},
    { title: 'Stevia', department: 'Pantry'},
    { title: 'Taro', department: 'Pantry'},
    { title: 'Tarragon', department: 'Pantry'},
    { title: 'Thyme', department: 'Pantry'},
    { title: 'Turmeric', department: 'Pantry'},
    { title: 'Vanilla Bean', department: 'Pantry'},
    { title: 'Vanilla Extract', department: 'Pantry'},
    { title: 'Vinegar', department: 'Pantry'},
    { title: 'White Pepper', department: 'Pantry'},
    { title: 'Yam', department: 'Pantry'},



    // Sauces & Dressings
    { title: '1000 Island Dressing', department: 'Pantry'},
    { title: 'Ajvar', department: 'Pantry'},
    { title: 'Arrabiata Sauce', department: 'Pantry'},
    { title: 'Balsamic Vinaigrette Dressing', department: 'Pantry'},
    { title: 'Barbecue Sauce', department: 'Pantry'},
    { title: 'Bechamel Sauce', department: 'Pantry'},
    { title: 'Bernaise Sauce', department: 'Pantry'},
    { title: 'Blue Cheese Dressing', department: 'Pantry'},
    { title: 'Bolognese', department: 'Pantry'},
    { title: 'Buttermilk Ranch Dressing', department: 'Pantry'},
    { title: 'Caesar Dressing', department: 'Pantry'},
    { title: 'Catalina Dressing', department: 'Pantry'},
    { title: 'Chasseur Dressing', department: 'Pantry'},
    { title: 'Chili Sauce', department: 'Pantry'},
    { title: 'Cream Sauce', department: 'Pantry'},
    { title: 'French Dressing', department: 'Pantry'},
    { title: 'Gravy', department: 'Pantry'},
    { title: 'Greek Dressing', department: 'Pantry'},
    { title: 'Hamburger Sauce', department: 'Pantry'},
    { title: 'Harissa', department: 'Pantry'},
    { title: 'Hollandaise Sauce', department: 'Pantry'},
    { title: 'Honey Mustard Dressing', department: 'Pantry'},
    { title: 'Italian Dressing', department: 'Pantry'},
    { title: 'Ketchup', department: 'Pantry'},
    { title: 'Mayonnaise', department: 'Pantry'},
    { title: 'Mustard', department: 'Pantry'},
    { title: 'Pesto', department: 'Pantry'},
    { title: 'Ranch Dressing', department: 'Pantry'},
    { title: 'Sesame Paste', department: 'Pantry'},
    { title: 'Soy Sauce', department: 'Pantry'},
    { title: 'Sweet and Sour Sauce', department: 'Pantry'},
    { title: 'Tabasco', department: 'Pantry'},
    { title: 'Teriyaki Sauce', department: 'Pantry'},
    { title: 'Thai Curry Paste', department: 'Pantry'},
    { title: 'Tomato Paste', department: 'Pantry'},
    { title: 'Tomato Puree', department: 'Pantry'},
    { title: 'Tomato Sauce', department: 'Pantry'},
    { title: 'Worcestershire Sauce', department: 'Pantry'},



    // Cheese Products
    { title: 'American Cheese', department: 'Dairy'},
    { title: 'Blue Cheese', department: 'Dairy'},
    { title: 'Brie', department: 'Dairy'},
    { title: 'Camembert', department: 'Dairy'},
    { title: 'Cheddar', department: 'Dairy'},
    { title: 'Colby Cheese', department: 'Dairy'},
    { title: 'Colby-Jack Cheese', department: 'Dairy'},
    { title: 'Dutch Cheese', department: 'Dairy'},
    { title: 'Edam Cheese', department: 'Dairy'},
    { title: 'Feta', department: 'Dairy'},
    { title: 'Fresh Mozzarella', department: 'Dairy'},
    { title: 'Goat Cheese', department: 'Dairy'},
    { title: 'Gorgonzola', department: 'Dairy'},
    { title: 'Gouda', department: 'Dairy'},
    { title: 'Grated Parmesan', department: 'Dairy'},
    { title: 'Italian Cheese', department: 'Dairy'},
    { title: 'Monterey Jack Cheese', department: 'Dairy'},
    { title: 'Monterey Cheese', department: 'Dairy'},
    { title: 'Mozzarella', department: 'Dairy'},
    { title: 'Parmesan', department: 'Dairy'},
    { title: 'Provolone', department: 'Dairy'},
    { title: 'Raclette Cheese', department: 'Dairy'},
    { title: 'Ricotta', department: 'Dairy'},
    { title: 'Romano', department: 'Dairy'},
    { title: 'Sheep Cheese', department: 'Dairy'},
    { title: 'String Cheese', department: 'Dairy'},
    { title: 'Swiss Cheese', department: 'Dairy'},
    { title: 'White Cheddar', department: 'Dairy'},
    { title: 'Wisconsin Cheese', department: 'Dairy'},



    // Lunch Meat
    { title: 'Baked Ham', department: 'Meat'},
    { title: 'Beef Salami', department: 'Meat'},
    { title: 'Boiled Ham', department: 'Meat'},
    { title: 'Bologna', department: 'Meat'},
    { title: 'Bresaola', department: 'Meat'},
    { title: 'Capicola', department: 'Meat'},
    { title: 'Pastrami', department: 'Meat'},
    { title: 'Pepperoni', department: 'Meat'},
    { title: 'Prosciutto', department: 'Meat'},
    { title: 'Smoked Ham', department: 'Meat'},
    { title: 'Turkey Ham', department: 'Meat'},
    { title: 'Turkey Salami', department: 'Meat'},




    // Bakery Items
    { title: 'All Purpose Flour', department: 'Bakery'},
    { title: 'Almond Extract', department: 'Bakery'},
    { title: 'Agave Syrup', department: 'Bakery'},
    { title: 'Agar-Agar', department: 'Bakery'},
    { title: 'Apple Pie Filling', department: 'Bakery'},
    { title: 'Baking Powder', department: 'Bakery'},
    { title: 'Baking Soda', department: 'Bakery'},
    { title: 'Bread Flour', department: 'Bakery'},
    { title: 'Brittle', department: 'Bakery'},
    { title: 'Brown Sugar', department: 'Bakery'},
    { title: 'Butterscotch Chips', department: 'Bakery'},
    { title: 'Cake Flour', department: 'Bakery'},
    { title: 'Candied Orange Peel', department: 'Bakery'},
    { title: 'Cane Sugar', department: 'Bakery'},
    { title: 'Chocolate Chips', department: 'Bakery'},
    { title: 'Chocolate Sprinkles', department: 'Bakery'},
    { title: 'Cocoa Powder', department: 'Bakery'},
    { title: 'Coconut Flakes', department: 'Bakery'},
    { title: 'Corn Flour', department: 'Bakery'},
    { title: 'Corn Syrup', department: 'Bakery'},
    { title: 'Cornstarch', department: 'Bakery'},
    { title: 'Couverture', department: 'Bakery'},
    { title: 'Custard powder', department: 'Bakery'},
    { title: 'Dark Rum', department: 'Bakery'},
    { title: 'Dextrose', department: 'Bakery'},
    { title: 'Dried Apricots', department: 'Bakery'},
    { title: 'Dried Cranberries', department: 'Bakery'},
    { title: 'Dried Figs', department: 'Bakery'},
    { title: 'Dried Prunes', department: 'Bakery'},
    { title: 'Egg Nog', department: 'Bakery'},
    { title: 'Egg White', department: 'Bakery'},
    { title: 'Egg Yolk', department: 'Bakery'},
    { title: 'Flour', department: 'Bakery'},
    { title: 'Fructose', department: 'Bakery'},
    { title: 'Gelatin', department: 'Bakery'},
    { title: 'Glucose', department: 'Bakery'},
    { title: 'Glucose Syrup', department: 'Bakery'},
    { title: 'Granulated Sugar', department: 'Bakery'},
    { title: 'Ground Cinnamon', department: 'Bakery'},
    { title: 'Hazelnuts', department: 'Bakery'},
    { title: 'Heavy Cream', department: 'Bakery'},
    { title: 'Jaggery', department: 'Bakery'},
    { title: 'Lemon Pie Filling', department: 'Bakery'},
    { title: 'Malt Powder', department: 'Bakery'},
    { title: 'Malted Milk', department: 'Bakery'},
    { title: 'Maltitol', department: 'Bakery'},
    { title: 'Maltodextrin', department: 'Bakery'},
    { title: 'Maltose', department: 'Bakery'},
    { title: 'Maple Syrup', department: 'Bakery'},
    { title: 'Molasses', department: 'Bakery'},
    { title: 'Nonpareils', department: 'Bakery'},
    { title: 'Peppermint Extract', department: 'Bakery'},
    { title: 'Powdered Milk', department: 'Bakery'},
    { title: 'Powdered Sugar', department: 'Bakery'},
    { title: 'Protein Powder', department: 'Bakery'},
    { title: 'Rock Sugar', department: 'Bakery'},
    { title: 'Rolled Oats', department: 'Bakery'},
    { title: 'Rum', department: 'Bakery'},
    { title: 'Shredded Coconut', department: 'Bakery'},
    { title: 'Sorbitol', department: 'Bakery'},
    { title: 'Soy Protein Powder', department: 'Bakery'},
    { title: 'Sprinkles', department: 'Bakery'},
    { title: 'Starch', department: 'Bakery'},
    { title: 'Strawberry Preserves', department: 'Bakery'},
    { title: 'Sucrose', department: 'Bakery'},
    { title: 'Sugar', department: 'Bakery'},
    { title: 'Sweetener', department: 'Bakery'},
    { title: 'Vanilla Sugar', department: 'Bakery'},
    { title: 'Vegetable Shoretning', department: 'Bakery'},
    { title: 'Whole Wheat Flour', department: 'Bakery'},
    { title: 'Xylitol', department: 'Bakery'},
    { title: 'Yeast', department: 'Bakery'},



    // Pastries
    { title: 'Apple Pie', department: 'Bakery'},
    { title: 'Apple Turnover', department: 'Bakery'},
    { title: 'Bagel', department: 'Bakery'},
    { title: 'Baguette', department: 'Bakery'},
    { title: 'Banana Bread', department: 'Bakery'},
    { title: 'Banana Nut Bread', department: 'Bakery'},
    { title: 'Beer Bread', department: 'Bakery'},
    { title: 'Biscuit', department: 'Bakery'},
    { title: 'Black Bread', department: 'Bakery'},
    { title: 'Bran Muffins', department: 'Bakery'},
    { title: 'Bread Pudding', department: 'Bakery'},
    { title: 'Breadsticks', department: 'Bakery'},
    { title: 'Brioche', department: 'Bakery'},
    { title: 'Brown Bread', department: 'Bakery'},
    { title: 'Brownies', department: 'Bakery'},
    { title: 'Bun', department: 'Bakery'},
    { title: 'Cannoli', department: 'Bakery'},
    { title: 'Caramel Cake', department: 'Bakery'},
    { title: 'Challah', department: 'Bakery'},
    { title: 'Chapati', department: 'Bakery'},
    { title: 'Ciabatta', department: 'Bakery'},
    { title: 'Cinnamon Bun', department: 'Bakery'},
    { title: 'Coffee Cake', department: 'Bakery'},
    { title: 'Conchas', department: 'Bakery'},
    { title: 'Cornbread', department: 'Bakery'},
    { title: 'Crepes', department: 'Bakery'},
    { title: 'Croissant', department: 'Bakery'},
    { title: 'Crumpet', department: 'Bakery'},
    { title: 'Cupcakes', department: 'Bakery'},
    { title: 'Donut', department: 'Bakery'},
    { title: 'Dosa', department: 'Bakery'},
    { title: 'Empanada', department: 'Bakery'},
    { title: 'English Muffin', department: 'Bakery'},
    { title: 'Flatbread', department: 'Bakery'},
    { title: 'Focaccia', department: 'Bakery'},
    { title: 'Garlic Bread', department: 'Bakery'},
    { title: 'Hot Dog Buns', department: 'Bakery'},
    { title: 'Italian Bread', department: 'Bakery'},
    { title: 'Latkes', department: 'Bakery'},
    { title: 'Matzo Bread', department: 'Bakery'},
    { title: 'Monkey Bread', department: 'Bakery'},
    { title: 'Muffin', department: 'Bakery'},
    { title: 'Multi-Grain Bread', department: 'Bakery'},
    { title: 'Naan', department: 'Bakery'},
    { title: 'Oatmeal Cookies', department: 'Bakery'},
    { title: 'Oatmeal Raisin Cookies', department: 'Bakery'},
    { title: 'Pan de Sal', department: 'Bakery'},
    { title: 'Pancake', department: 'Bakery'},
    { title: 'Pandesal', department: 'Bakery'},
    { title: 'Panettone', department: 'Bakery'},
    { title: 'Pide', department: 'Bakery'},
    { title: 'Pie', department: 'Bakery'},
    { title: 'Pita Bread', department: 'Bakery'},
    { title: 'Potato Bread', department: 'Bakery'},
    { title: 'Pretzel', department: 'Bakery'},
    { title: 'Pretzel Roll', department: 'Bakery'},
    { title: 'Puff Pastry', department: 'Bakery'},
    { title: 'Pumpernickel', department: 'Bakery'},
    { title: 'Raisin Bread', department: 'Bakery'},
    { title: 'Roll', department: 'Bakery'},
    { title: 'Roti', department: 'Bakery'},
    { title: 'Rye Bread', department: 'Bakery'},
    { title: 'Sandwich Bread', department: 'Bakery'},
    { title: 'Scone', department: 'Bakery'},
    { title: 'Shortcrust Pastry', department: 'Bakery'},
    { title: 'Soda Bread', department: 'Bakery'},
    { title: 'Souffle', department: 'Bakery'},
    { title: 'Sourdough Bread', department: 'Bakery'},
    { title: 'Spanakopita', department: 'Bakery'},
    { title: 'Spice Cake', department: 'Bakery'},
    { title: 'Sweet Rolls', department: 'Bakery'},
    { title: 'Swiss Roll', department: 'Bakery'},
    { title: 'Toast', department: 'Bakery'},
    { title: 'White Bread', department: 'Bakery'},
    { title: 'Whole Wheat Bread', department: 'Bakery'},



    // Canned Soup
    { title: 'Alphabet Soup', department: 'Pantry'},
    { title: 'Bean Stew', department: 'Pantry'},
    { title: 'Beef Bouillon', department: 'Pantry'},
    { title: 'Beef Soup', department: 'Pantry'},
    { title: 'Broccoli Cheese Soup', department: 'Pantry'},
    { title: 'Broccoli Soup', department: 'Pantry'},
    { title: 'Chicken Bouillon', department: 'Pantry'},
    { title: 'Chicken Noodle Soup', department: 'Pantry'},
    { title: 'Chicken Vegetable Soup', department: 'Pantry'},
    { title: 'Chicken with Rice Soup', department: 'Pantry'},
    { title: 'Cream of Asparagus Soup', department: 'Pantry'},
    { title: 'Cream of Broccoli Soup', department: 'Pantry'},
    { title: 'Cream of Celery Soup', department: 'Pantry'},
    { title: 'Cream of Chicken Soup', department: 'Pantry'},
    { title: 'Cream of Mushroom Soup', department: 'Pantry'},
    { title: 'Cream of Onion Soup', department: 'Pantry'},
    { title: 'Cream of Potato Soup', department: 'Pantry'},
    { title: 'Creamy Chicken Noodle Soup', department: 'Pantry'},
    { title: 'French Onion Soup', department: 'Pantry'},
    { title: 'Golden Mushroom Soup', department: 'Pantry'},
    { title: 'Goulash', department: 'Pantry'},
    { title: 'Instant Ramen', department: 'Pantry'},
    { title: 'Lentil Soup', department: 'Pantry'},
    { title: 'Lobster Bisque Soup', department: 'Pantry'},
    { title: 'Meatball Soup', department: 'Pantry'},
    { title: 'Minnestrone', department: 'Pantry'},
    { title: 'Mushroom Soup', department: 'Pantry'},
    { title: 'Noodle Soup', department: 'Pantry'},
    { title: 'Onion Soup', department: 'Pantry'},
    { title: 'Pea Soup', department: 'Pantry'},
    { title: 'Potato Soup', department: 'Pantry'},
    { title: 'Pumpkin Soup', department: 'Pantry'},
    { title: 'Ramen', department: 'Pantry'},
    { title: 'Scotch Broth', department: 'Pantry'},
    { title: 'Thai Soup', department: 'Pantry'},
    { title: 'Tomato Rice Soup', department: 'Pantry'},
    { title: 'Tomato Soup', department: 'Pantry'},
    { title: 'Vegetable Beef Soup', department: 'Pantry'},
    { title: 'Vegetable Broth', department: 'Pantry'},
    { title: 'Vegetable Soup', department: 'Pantry'},
    { title: 'Vegetable Stock', department: 'Pantry'},
    { title: 'Wedding Soup', department: 'Pantry'},



    // Alcoholic Items
    { title: 'Absinthe', department: 'Beverages'},
    { title: 'Advocaat', department: 'Beverages'},
    { title: 'Amaretto', department: 'Beverages'},
    { title: 'Applejack', department: 'Beverages'},
    { title: 'Asti', department: 'Beverages'},
    { title: 'Baileys', department: 'Beverages'},
    { title: 'Baileys Irish Cream', department: 'Beverages'},
    { title: 'Beer', department: 'Beverages'},
    { title: 'Blue Curacao', department: 'Beverages'},
    { title: 'Bourbon', department: 'Beverages'},
    { title: 'Brandy', department: 'Beverages'},
    { title: 'Canadian Whiskey', department: 'Beverages'},
    { title: 'Chambord', department: 'Beverages'},
    { title: 'Champagne', department: 'Beverages'},
    { title: 'Cider', department: 'Beverages'},
    { title: 'Cognac', department: 'Beverages'},
    { title: 'Cointreau', department: 'Beverages'},
    { title: 'Drambuie', department: 'Beverages'},
    { title: 'Frangelico', department: 'Beverages'},
    { title: 'Gin', department: 'Beverages'},
    { title: 'Glenfiddich', department: 'Beverages'},
    { title: 'Grand Marnier', department: 'Beverages'},
    { title: 'Irish Whiskey', department: 'Beverages'},
    { title: 'Jack Daniels', department: 'Beverages'},
    { title: 'Jagermeister', department: 'Beverages'},
    { title: 'Jim Beam', department: 'Beverages'},
    { title: 'Kahlua', department: 'Beverages'},
    { title: 'Liquer', department: 'Beverages'},
    { title: 'Liquor', department: 'Beverages'},
    { title: 'Midori', department: 'Beverages'},
    { title: 'Prosecco', department: 'Beverages'},
    { title: 'Punch', department: 'Beverages'},
    { title: 'Red Wine', department: 'Beverages'},
    { title: 'Rose Wine', department: 'Beverages'},
    { title: 'Sambuca', department: 'Beverages'},
    { title: 'Sangria', department: 'Beverages'},
    { title: 'Scotch', department: 'Beverages'},
    { title: 'Sherry', department: 'Beverages'},
    { title: 'Sloe Gin', department: 'Beverages'},
    { title: 'Southern Comfort', department: 'Beverages'},
    { title: 'Tequila', department: 'Beverages'},
    { title: 'Triple Sec', department: 'Beverages'},
    { title: 'Vermouth', department: 'Beverages'},
    { title: 'Vodka', department: 'Beverages'},
    { title: 'Whiskey', department: 'Beverages'},
    { title: 'White Wine', department: 'Beverages'},
    { title: 'Wine', department: 'Beverages'},



    // Soda
    { title: '7up', department: 'Beverages'},
    { title: 'Ginger Ale', department: 'Beverages'},
    { title: 'Cherry Coke', department: 'Beverages'},
    { title: 'Coke', department: 'Beverages'},
    { title: 'Coke Zero', department: 'Beverages'},
    { title: 'Diet Cherry Coke', department: 'Beverages'},
    { title: 'Diet Coke', department: 'Beverages'},
    { title: 'Diet Dr.Pepper', department: 'Beverages'},
    { title: 'Diet Pepsi', department: 'Beverages'},
    { title: 'Diet Sunkist', department: 'Beverages'},
    { title: 'Dr.Pepper', department: 'Beverages'},
    { title: 'Fanta', department: 'Beverages'},
    { title: 'Fanta Zero', department: 'Beverages'},
    { title: 'Fresca', department: 'Beverages'},
    { title: 'Fuze', department: 'Beverages'},
    { title: 'Fuze Tea', department: 'Beverages'},
    { title: 'Gatorade', department: 'Beverages'},
    { title: 'Ice Tea', department: 'Beverages'},
    { title: 'Kool-Aid', department: 'Beverages'},
    { title: 'Lemonade', department: 'Beverages'},
    { title: 'Mello Yello', department: 'Beverages'},
    { title: 'Minute Maid', department: 'Beverages'},
    { title: 'Minute Maid Light', department: 'Beverages'},
    { title: 'Mug Root Beer', department: 'Beverages'},
    { title: 'Orange Soda', department: 'Beverages'},
    { title: 'Pepsi', department: 'Beverages'},
    { title: 'Powerade', department: 'Beverages'},
    { title: 'Soda', department: 'Beverages'},
    { title: 'Sprite', department: 'Beverages'},
    { title: 'Sprite Zero', department: 'Beverages'},
    { title: 'Squirt', department: 'Beverages'},
    { title: 'Sunkist', department: 'Beverages'},
    { title: 'Surge', department: 'Beverages'},
    { title: 'Tonic Water', department: 'Beverages'},
    { title: 'Vanilla Coke', department: 'Beverages'},




    // Non-Alcoholic Beverages
    { title: 'Apple Spritzer', department: 'Beverages'},
    { title: 'Chai', department: 'Beverages'},
    { title: 'Chcolate Milk', department: 'Beverages'},
    { title: 'Coffee', department: 'Beverages'},
    { title: 'Crystal Light', department: 'Beverages'},
    { title: 'Evian', department: 'Beverages'},
    { title: 'Ginger Tea', department: 'Beverages'},
    { title: 'Hawaiian Punch', department: 'Beverages'},
    { title: 'Hi-C', department: 'Beverages'},
    { title: 'Horhcata', department: 'Beverages'},
    { title: 'Hot Chocolate', department: 'Beverages'},
    { title: 'Karamalz', department: 'Beverages'},
    { title: 'Kombucha', department: 'Beverages'},
    { title: 'Lassi', department: 'Beverages'},
    { title: 'Milo', department: 'Beverages'},
    { title: 'Nectar', department: 'Beverages'},
    { title: 'Nestea', department: 'Beverages'},
    { title: 'Nesquik', department: 'Beverages'},
    { title: 'Slurpee', department: 'Beverages'},
    { title: 'Water', department: 'Beverages'},
    { title: 'Volvic', department: 'Beverages'},
    { title: 'Yerba Mate', department: 'Beverages'},



    // Fruit Juices
    { title: 'Acai Juice', department: 'Beverages'},
    { title: 'Aloe Vera', department: 'Beverages'},
    { title: 'Apple Juice', department: 'Beverages'},
    { title: 'Apricot Nectar', department: 'Beverages'},
    { title: 'Banana Juice', department: 'Beverages'},
    { title: 'Blackberry Juice', department: 'Beverages'},
    { title: 'Capri-Sun', department: 'Beverages'},
    { title: 'Carrot Juice', department: 'Beverages'},
    { title: 'Chamomile Tea', department: 'Beverages'},
    { title: 'Cherry Juice', department: 'Beverages'},
    { title: 'Clamato', department: 'Beverages'},
    { title: 'Coconut Water', department: 'Beverages'},
    { title: 'Cranberry Juice', department: 'Beverages'},
    { title: 'Cucumber Juice', department: 'Beverages'},
    { title: 'Currant Juice', department: 'Beverages'},
    { title: 'Fruitopia', department: 'Beverages'},
    { title: 'Grape Juice', department: 'Beverages'},
    { title: 'Grapefruit Juice', department: 'Beverages'},
    { title: 'Lemon Juice', department: 'Beverages'},
    { title: 'Lime Juice', department: 'Beverages'},
    { title: 'Mango Lassi', department: 'Beverages'},
    { title: 'Orange Juice', department: 'Beverages'},
    { title: 'Papaya Juice', department: 'Beverages'},
    { title: 'Passion Fruit Juice', department: 'Beverages'},
    { title: 'Peach Juice', department: 'Beverages'},
    { title: 'Peach Nectar', department: 'Beverages'},
    { title: 'Pear Juice', department: 'Beverages'},
    { title: 'Pineapple Juice', department: 'Beverages'},
    { title: 'Pineapple Orange Juice', department: 'Beverages'},
    { title: 'Plum Juice', department: 'Beverages'},
    { title: 'Pomegranate Juice', department: 'Beverages'},
    { title: 'Sauerkraut Juice', department: 'Beverages'},
    { title: 'Tangerine Juice', department: 'Beverages'},
    { title: 'Tomato Juice', department: 'Beverages'},
    { title: 'Vegetable Juice', department: 'Beverages'},
    { title: 'White Grape Juice', department: 'Beverages'},



    // Frozen Items
    { title: 'Pizza', department: 'Frozen'},
    { title: 'Frozen Bread', department: 'Frozen'},
    { title: 'Dumplings', department: 'Frozen'},
    { title: 'Potstickers', department: 'Frozen'},
    { title: 'FrozenEnchilada', department: 'Frozen'},
    { title: 'Frozen Mac n Cheese', department: 'Frozen'},
    { title: 'Chicken Sliders', department: 'Frozen'},
    { title: 'Fettuccini Alfredo', department: 'Frozen'},
    { title: 'Chili Mac n Cheese', department: 'Frozen'},
    { title: 'Frozen Ravioli', department: 'Frozen'},
    { title: 'Frozen Chicken Tenders', department: 'Frozen'},
    { title: 'Corn Dogs', department: 'Frozen'},
    { title: 'Frozen Burrito', department: 'Frozen'},
    { title: 'Frozen Curry', department: 'Frozen'},
    { title: 'Meatballs', department: 'Frozen'},
    { title: 'Taquitos', department: 'Frozen'},
    { title: 'Sliders', department: 'Frozen'},
    { title: 'White Castle', department: 'Frozen'},
    { title: "Shepherd's Pie", department: 'Frozen'},
    { title: 'Pot Pie', department: 'Frozen'},
    { title: 'Frozen Shrimp', department: 'Frozen'},
    { title: 'Alfredo', department: 'Frozen'},
    { title: 'Egg Rolls', department: 'Frozen'},
    { title: 'Eggo Waffles', department: 'Frozen'},
    { title: 'Egg and Cheese Croissant', department: 'Frozen'},
    { title: 'Uncrustables', department: 'Frozen'},
    { title: 'Hash Browns', department: 'Frozen'},
    { title: 'Fries', department: 'Frozen'},
    { title: 'Mozzarella Cheese Sticks', department: 'Frozen'},
    { title: 'Frozen Cauliflower', department: 'Frozen'},
    { title: 'Frozen Borccoli', department: 'Frozen'},
    { title: 'Frozen Corn', department: 'Frozen'},
    { title: 'Frozen Green Peas', department: 'Frozen'},
    { title: 'Crushed Garlic', department: 'Frozen'},
    { title: 'Frozen Pepper & Onion', department: 'Frozen'},
    { title: 'Frozen Mixed Vegetables', department: 'Frozen'},
    { title: 'Frozen Brussel Sprouts', department: 'Frozen'},
    { title: 'Frozen Spinach', department: 'Frozen'},
    { title: 'Frozen Green Beans', department: 'Frozen'},
    { title: 'Frozen Edamame', department: 'Frozen'},
    { title: 'Frozen Salmon', department: 'Frozen'},
    { title: 'Frozen Tilapia', department: 'Frozen'},
    { title: 'Frozen Spring Rolls', department: 'Frozen'},
    { title: 'Frozen Catfish', department: 'Frozen'},
    { title: 'Frozen Crab Cakes', department: 'Frozen'},
    { title: 'Frozen Tempura Shrimp', department: 'Frozen'},
    { title: 'Frozen Tuna', department: 'Frozen'},
    { title: 'Frozen Fish Sticks', department: 'Frozen'},
    { title: 'Frozen Scallops', department: 'Frozen'},
    { title: 'Frozen Salmon Burgers', department: 'Frozen'},
    { title: 'Frozen Onion Rings', department: 'Frozen'},
    { title: 'Frozen Tater Tots', department: 'Frozen'},
    { title: 'Frozen Waffle Fries', department: 'Frozen'},
    { title: 'Frozen Mashed Potatoes', department: 'Frozen'},


    // Household Items
    { title: 'Bath Tissue', department: 'Household'},
    { title: 'Paper Towels', department: 'Household'},
    { title: 'Napkins', department: 'Household'},
    { title: 'Lunch Bags', department: 'Household'},
    { title: 'Paper Plates', department: 'Household'},
    { title: 'Plastic Cutlery', department: 'Household'},
    { title: 'Paper Cups', department: 'Household'},
    { title: 'Sandwich Bags', department: 'Household'},
    { title: 'Freezer Bags', department: 'Household'},
    { title: 'Plastic Wrap', department: 'Household'},
    { title: 'Aluminum Foil', department: 'Household'},
    { title: 'Waxed Paper', department: 'Household'},
    { title: 'Parchment Paper', department: 'Household'},
    { title: 'Trash Bags', department: 'Household'},
    { title: 'Dish Soap', department: 'Household'},
    { title: 'Dishwasher Detergent', department: 'Household'},
    { title: 'Finish', department: 'Household'},
    { title: 'Glass Cleaner', department: 'Household'},
    { title: 'Multipurpose Cleaner', department: 'Household'},
    { title: 'Swiffer Mop', department: 'Household'},
    { title: 'Furniture Polish', department: 'Household'},
    { title: 'Clorox Wipes', department: 'Household'},
    { title: 'Toilet-Bowl Cleaner', department: 'Household'},
    { title: 'Soft Scrub', department: 'Household'},
    { title: 'Bleach', department: 'Household'},
    { title: 'Sponges', department: 'Household'},
    { title: 'Air Freshener', department: 'Household'},
    { title: 'Febreze', department: 'Household'},
    { title: 'Magic Erasers', department: 'Household'},
    { title: 'Floor Wax', department: 'Household'},
    { title: 'Laundry Detergent', department: 'Household'},
    { title: 'Fabric Softener', department: 'Household'},
    { title: 'Dryer Sheets', department: 'Household'},
    { title: 'Oxi-Clean', department: 'Household'},
    { title: 'Stain Remover', department: 'Household'},
    { title: 'Bleach Pen', department: 'Household'},
    { title: 'Shampoo', department: 'Household'},
    { title: 'Conditioner', department: 'Household'},
    { title: 'Body Wash', department: 'Household'},
    { title: 'Hand Soap', department: 'Household'},
    { title: 'Bath Poufs', department: 'Household'},
    { title: 'Toothpaste', department: 'Household'},
    { title: 'Mouthwash', department: 'Household'},
    { title: 'Deodrant', department: 'Household'},
    { title: 'Feminine Products', department: 'Household'},
    { title: 'Baby Wipes', department: 'Household'},
    { title: 'Razors', department: 'Household'},
    { title: 'Band-Aids', department: 'Household'},
    { title: 'Kleenex', department: 'Household'},
    { title: 'Dental Floss', department: 'Household'},
    { title: 'Pain Reliever', department: 'Household'},
    { title: 'Allergy Medicine', department: 'Household'},
    { title: 'Neosporin', department: 'Household'},
    { title: 'Hairspray', department: 'Household'},
    { title: 'Make-up', department: 'Household'},
    { title: 'Cotton Balls', department: 'Household'},
    { title: 'Q-Tips', department: 'Household'},
    { title: 'Hand Santizier', department: 'Household'},
    { title: 'Make-up Remover', department: 'Household'},
    { title: 'Contact Solution', department: 'Household'},
    { title: 'Hydrogen Peroxide', department: 'Household'},
    { title: 'Rubbing Alcohol', department: 'Household'},
    { title: 'Light Bulbs', department: 'Household'},
    { title: 'Pens', department: 'Household'},
    { title: 'Pencil', department: 'Household'},
    { title: 'Printer Ink', department: 'Household'},
    { title: 'Batteries', department: 'Household'},
    { title: 'Ointment', department: 'Household'},
    { title: 'Emergen-C', department: 'Household'},
    { title: 'Airborne', department: 'Household'},
    { title: 'Benadryl', department: 'Household'},
    { title: 'Advil', department: 'Household'},
    { title: 'Tylenol', department: 'Household'},
  ];

  export default listOfStock;